<template>
  <aw-modal
    :opened="opened"
    size="lg"
    :closable="closable"
    :modal-title="title"
    @close-modal="closeModal"
  >
    <template #content>
      <div :class="$style.wrapper">
        <aw-separator margin-top="none" />
        <div :class="$style.warningContainer">
          <lv-icon
            :size="64"
            name="alert-triangle"
            fill
            :square="false"
          />
          <p v-html="message" />
        </div>
        <aw-separator />
        <slot name="actionButtons" />
      </div>
    </template>
  </aw-modal>
</template>

<script setup>
  import { LvIcon } from '~~/common/components/loginet-vue-shop/index';
  import AwModal from '~~/common/components/Common/AwModal';

  import { useModalStore } from '~~/common/stores/modal';
  import AwSeparator from '~~/common/components/Common/AwSeparator.vue';
  import { M_WARNING } from '~~/common/config/Modal';


  defineProps({
    title: {
      type: String,
      default: '',
      required: true,
    },
    message: {
      type: String,
      default: '',
      required: true,
    },
    closable: {
      type: Boolean,
      default: true,
    },
  });

  const emits = defineEmits([
    'close-modal',
  ]);

  const modal = computed(() => {
    return useModalStore().activeGenericModal;
  });

  const opened = computed(() => {
    return modal.value.type === M_WARNING;
  });

  function closeModal () {
    emits('close-modal');
  }
</script>

<style module lang="scss" rel="stylesheet/scss">
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
}

.warningContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 40px 16px;
  color: $color-text-marigold;
  border-radius: 12px;
  background-color: $color-marigold-300--12;
  gap: 12px;
}
</style>
